import { Box } from "@mui/material";
import {
  createSearchParams,
  Link as RouterLink,
  useNavigate,
} from "react-router-dom";
import Chip from "src/components/common/Chip";
import { Button } from "src/components/common/FormComponents";
import { CHIP_STATUS, PROJECT_STATUS } from "src/constants/common";
import { path } from "src/constants/path";
import defaultStyles from "../styles";
import { useAppSelector } from "src/redux/store";

export const RenderChip = (params) => {
  return (
    <Chip
      label={PROJECT_STATUS[params.row.chipTitle]}
      status={CHIP_STATUS[params.row.status]}
      description={params.row.remarks}
      showTooltip={PROJECT_STATUS[params.row.chipTitle] === "Rejected"}
    />
  );
};

export const RenderButton = (params) => {
  return (
    <>
      <Box
        component={RouterLink}
        to={`${"/activity/details"}?${createSearchParams({
          projectId: params.id,
          projectType: params.row.data.projectType,
        })}`}
        sx={{ ...defaultStyles.renderButtonText2 }}
      >{`${params?.row?.registrationNo}`}</Box>
    </>
  );
};

export const RenderDemandDraft = (params) => {
  const navigate = useNavigate();
  return (
    <>
      {params?.row?.status === "PAYMENT_PENDING" ? (
        <Box
          component={RouterLink}
          to={`${path.demandNote}?${createSearchParams({
            id: params.id,
          })}`}
          sx={{ ...defaultStyles.renderButtonText2 }}
        >{`${"Make Payment"}`}</Box>
      ) : (
        <Box sx={{ color: "red" }}>----</Box>
      )}
    </>
  );
};

export const RenderView = (params) => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        component={RouterLink}
        to={`${"/landownership-details"}?${createSearchParams({
          id: params.row.id,
        })}`}
        sx={{ ...defaultStyles.renderButtonText2 }}
      >{`${params?.row?.id}`}</Box>
    </>
  );
};

export const RenderEditLandButton = (params) => {
  const user = useAppSelector((state) => state.root.user);

  return (
    <>
      {params.row.status === "APPROVED" &&
      user.data.role === "Implementing Agency" &&
      user.data.userType !== "INDIVIDUAL" ? (
        <Box
          component={RouterLink}
          to={`${"/activity/details"}?${createSearchParams({
            projectId: params.id,
            projectType: params.row.data.projectType,
          })}`}
          sx={{ ...defaultStyles.renderButtonText2 }}
        >
          Edit land
        </Box>
      ) : (
        <Box sx={{ color: "red" }}>----</Box>
      )}
    </>
  );
};
